import { getDomain } from '@libs/utils';

export const languageLocale = getDomain.getLanguageLocale();

export const mapLanguageLocale = getDomain.isDanishMarket
  ? 'da'
  : languageLocale;
